/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  Navigate,
  Route,
  Routes,
  Switch,
  useLocation,
  useMatch
} from 'react-router-dom';
import Step1 from '../../component/WorkOrder/CreateWorkOrder/Step1/SelectWOType.view';
import SelectWOTypeInPage from '../../component/WorkOrder/CreateWorkOrder/Step1/SelectWOTypeInPage';
import CreateWOStep2 from '../../component/WorkOrder/CreateWorkOrder/Step2/SelectionFilter';
import CreateWOStep3 from '../../component/WorkOrder/CreateWorkOrder/Step3/Step3';
import { useActions } from '../../store/hooks/useActions';

const CreateWORoutes = ({ createdFrom }) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const match = useMatch(pathname);
  const { pathname: path } = match;
  // console.log(match, path, 'checking');
  const { setWorkOrderDetail } = useActions();

  useEffect(() => {
    if (createdFrom) {
      setWorkOrderDetail({
        workOrderCreationFrom: createdFrom
      });
    }
  }, [createdFrom]);

  return (
    <Routes>
      <Route
        path={`${path}/select_WO_type`}
        exact
        name='select_WO_type'
        element={(props) => <SelectWOTypeInPage {...props} />}
      />
      <Route
        path='/filter'
        exact
        name='create_WO_filter'
        element={<CreateWOStep2 />}
      />
      {/* <Route path={`${path}/spares`} exact name='create_WO_spares' render={(props) => <>Select spares</>} /> */}
      <Route
        path='/form'
        exact
        name='create_WO_form'
        element={<CreateWOStep3 />}
      />
    </Routes>
  );
};

export default CreateWORoutes;
